module.exports = __webpack_public_path__ + "static/media/de.98925713.svg";